/* =========================================================
   AF — Page Loader
   - Progress ring fills to match the percentage counter
   - Completes to 100% before fading out
   - Safe for bfcache (no beforeunload)
   ========================================================= */
(() => {
  if (window.__af_page_loader_safe) return;
  window.__af_page_loader_safe = true;

  const CIRCUMFERENCE = 113; // 2 * PI * 18
  const root = document.documentElement;

  const getLoader = () => document.getElementById('PageLoader');
  const getRingFg = () => {
    const el = getLoader();
    return el ? el.querySelector('.ring__fg') : null;
  };
  const getPctEl = () => {
    const el = getLoader();
    return el ? el.querySelector('.page-loader__pct') : null;
  };

  let timer = null;
  let pct = 0;
  let hideTimeout = null;
  let resetTimeout = null;
  let failsafe = null; // never leave the loader up if a navigation stalls or is cancelled

  const render = () => {
    const pctEl = getPctEl();
    const ringEl = getRingFg();
    if (pctEl) pctEl.textContent = String(Math.round(pct));
    if (ringEl) ringEl.style.strokeDashoffset = CIRCUMFERENCE - (CIRCUMFERENCE * pct / 100);
  };

  const cancelPendingHide = () => {
    if (failsafe) { clearTimeout(failsafe); failsafe = null; }
    if (hideTimeout) { clearTimeout(hideTimeout); hideTimeout = null; }
    if (resetTimeout) { clearTimeout(resetTimeout); resetTimeout = null; }
  };

  const startProgress = () => {
    stopProgress();
    pct = 0;
    render();

    timer = window.setInterval(() => {
      if (pct < 55) pct += 1.8;
      else if (pct < 80) pct += 0.8;
      else if (pct < 92) pct += 0.3;
      else if (pct < 96 && Math.random() < 0.2) pct += 0.5;
      else pct = Math.min(pct, 96);

      render();
    }, 60);
  };

  const stopProgress = () => {
    if (timer) {
      clearInterval(timer);
      timer = null;
    }
  };

  const show = () => {
    const el = getLoader();
    if (!el) return;
    cancelPendingHide();
    el.classList.add('is-on');
    startProgress();
    failsafe = window.setTimeout(hide, 8000);
  };

  const hide = () => {
    const el = getLoader();
    if (!el) return;
    stopProgress();
    cancelPendingHide();

    // Complete the ring to 100 before fading out
    pct = 100;
    render();

    hideTimeout = window.setTimeout(() => {
      hideTimeout = null;
      el.classList.remove('is-on');
      // Reset after fade-out transition completes
      resetTimeout = window.setTimeout(() => {
        resetTimeout = null;
        pct = 0;
        render();
      }, 300);
    }, 200);
  };

  // Kill any stuck state immediately
  root.classList.remove('af-loading');
  hide();

  // Hide when the page is ready
  window.addEventListener('load', () => {
    root.classList.remove('af-loading');
    hide();
  });

  // Back button / bfcache restore
  window.addEventListener('pageshow', (e) => {
    root.classList.remove('af-loading');
    hide();
  });

  // Stop, then switch tab and come back: the page never unloaded, so clear it.
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible' && getLoader()?.classList.contains('is-on')) {
      root.classList.remove('af-loading');
      hide();
    }
  });

  // Show loader on real link navigations
  document.addEventListener('click', (e) => {
    const link = e.target.closest('a[href]');
    if (!link) return;

    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.defaultPrevented) return;

    const href = link.getAttribute('href') || '';
    if (link.target === '_blank') return;
    if (/^(javascript:|mailto:|tel:|#)/.test(href)) return;

    try {
      const url = new URL(href, location.href);
      if (url.origin !== location.origin) return;
      if (url.pathname === location.pathname && url.search === location.search) return;
    } catch (_) { return; }

    show();
  }, { passive: true });

  window.AFPageLoader = { show, hide };
})();
